$(document).ready(function(){

  setTimeout(function(){
    var currentUrl = String(window.location.href);
      if(currentUrl.indexOf('#buy_now_section') != -1){
       $('html, body').animate({
                    scrollTop: $(".bs_outer").offset().top-200
                }, 500);
      }
  },500);
      
    $('.Livia_faq_cell').click(function(){
        $(this).toggleClass('active');
        $(this).find('.Livia_faq_content').slideToggle();
    });

    $(".Home_arrow_down").click(function() {
        $("html, body").animate({ scrollTop: $(window).height() }, 500);
    });

    $('.buy-now-cta-btn').click(function(evt){
        evt.preventDefault();
        $('html, body').animate({
            scrollTop: $(".Shilajit_products_list").offset().top-200
        }, 500);
    });

    $('.Faq_section_cell').click(function(){
        $(this).toggleClass('active');
        $(this).find('.Faq_content').slideToggle();
     });

    $('.Hero_video_scroll_button').click(function(){
      $('html, body').animate({
          scrollTop: $(".Shilajit_products_list").offset().top-200
      }, 500);
    });

    $('.Product_section_subscribtion_switch').click(function () {
      $(this).toggleClass('active');

      if ($(this).hasClass('active')){
        $('.ec_product_price__one').hide();
        $('.ec_product_price__sub').show();
      }
      else{
        $('.ec_product_price__one').show();
        $('.ec_product_price__sub').hide();
      }

      var currentData = parseFloat($('.bfp_cell.active').attr('data'));

      if (currentData == 48695738171707 ){
        if ($('.Product_section_subscribtion_switch').hasClass('active')){
            currentData = 48695742464315;
        }
      }


      $('.bd_product_price').hide();
      $('.bd_product_price[data="'+currentData+'"]').show();
      $('.bf_total_price').hide()
      $('.bf_total_price[data="'+currentData+'"]').css('display', 'flex');
      $('.bd_product_price_save').hide();
      $('.bd_product_price_save[data="'+currentData+'"]').show();

      $('.bfp_atc').attr('data-id', currentData);
      
    });


    // Mountains animation

    $(window).on('scroll', function() {
      var scrollTop = $(window).scrollTop();
      var maOuter = $('.ma_outer');
      var maOuterTop = maOuter.offset().top - 100;
      var maOuterHeight = 5000;
  
      if (scrollTop >= maOuterTop) {
          var scrolled = scrollTop - maOuterTop;
          var percentScrolled = (scrolled / maOuterHeight) * 100;
          if (percentScrolled > 100) {
              percentScrolled = 100;
          }

        // First scene
         if (percentScrolled > 0 && percentScrolled < 15){

          $('.ma_hero_slide[data="2slide"]').addClass('hidded');
          $('.ma_hero_slide[data="3slide"]').addClass('hidded');
          $('.ma_hero_slide[data="4slide"]').addClass('hidded');
          $('.ma_hero_slide[data="5slide"]').addClass('hidded');
          $('.ma_hero_slide[data="6slide"]').addClass('hidded');
          $('.ma_hero_slide[data="7slide"]').addClass('hidded');

          var transformPercent = ((percentScrolled/100) * 5) + 1;

          var transformPercentmob  = ((percentScrolled/100) * 10) + 1;

          var topPosition = (percentScrolled * 13);
          var leftPosition = percentScrolled * 15;

          var topPositionmob = (percentScrolled * 5);
          var leftPositionmob = percentScrolled * 13;
          

          if (percentScrolled > 3) {
            $('.ma_hero_slide[data="1slide"]').addClass('hidded');
          } else {
              $('.ma_hero_slide[data="1slide"]').removeClass('hidded');
          }
          // console.log(topPosition, leftPosition)
          $('.ma_bg_image.Desktop_only').css('transform', 'scale('+transformPercent+')');
          $('.ma_bg_image.Mobile_only').css('transform', 'scale('+transformPercentmob+')');

          $('.ma_bg_image.Desktop_only').css('top', '-'+topPosition + 'px');
          $('.ma_bg_image.Desktop_only').css('left', '-'+leftPosition + 'px');
          $('.ma_bg_image.Mobile_only').css('top', '-'+topPositionmob + 'px');
          $('.ma_bg_image.Mobile_only').css('left', '-'+leftPositionmob + 'px');

          $('.ma_inner').attr('data-scrolled-x',leftPosition);
          $('.ma_inner').attr('data-scrolled-y',topPosition);
          $('.ma_inner').attr('data-percent-old', percentScrolled);

          $('.ma_inner').attr('data-scrolled-xmob',leftPositionmob);
          $('.ma_inner').attr('data-scrolled-ymob',topPositionmob);
          
          $('.ma_bg_image_outer').removeClass('loaded');
        }
        //  Second scene
        else if (percentScrolled > 15 && percentScrolled < 25){

          $('.ma_bg_image_outer').addClass('loaded');
          var startX = parseFloat($('.ma_inner').attr('data-scrolled-x'));
          var startY = parseFloat($('.ma_inner').attr('data-scrolled-y'));
          var startXmob = parseFloat($('.ma_inner').attr('data-scrolled-xmob'));
          var startYmob = parseFloat($('.ma_inner').attr('data-scrolled-ymob'));

          var startPercent = parseFloat($('.ma_inner').attr('data-percent-old'));

          var transformPercent = (percentScrolled - startPercent) * 3;


          // console.log(transformPercent, startPercent);

          var topPosition = startY - transformPercent;
          var leftPosition = startX - transformPercent;
          var topPositionmob = startYmob - (transformPercent);
          var leftPositionmob = startXmob - transformPercent;

          // console.log(startXmob, leftPositionmob);

          $('.ma_bg_image.Desktop_only').css('top', '-'+topPosition + 'px');
          $('.ma_bg_image.Desktop_only').css('left', '-'+leftPosition + 'px');
          $('.ma_bg_image.Mobile_only').css('top', '-'+topPositionmob + 'px');
          $('.ma_bg_image.Mobile_only').css('left', '-'+leftPositionmob + 'px');
          
          $('.ma_hero_slide[data="2slide"]').removeClass('hidded');
          $('.ma_hero_slide[data="3slide"]').addClass('hidded');
          $('.ma_hero_slide[data="4slide"]').addClass('hidded');
          $('.ma_hero_slide[data="5slide"]').addClass('hidded');
          $('.ma_hero_slide[data="6slide"]').addClass('hidded');
          $('.ma_hero_slide[data="7slide"]').addClass('hidded');

          $('.ma_inner').attr('data-scrolled-x',leftPosition);
          $('.ma_inner').attr('data-scrolled-y',topPosition);

          $('.ma_inner').attr('data-scrolled-xmob',leftPositionmob);
          $('.ma_inner').attr('data-scrolled-ymob',topPositionmob);

          $('.ma_inner').attr('data-percent-old', percentScrolled);
        }
        //  Third scene
        else if (percentScrolled > 25 && percentScrolled < 40){
          var transformPercent = ((percentScrolled/100) * 2) + 1;
          var topPosition = (percentScrolled * 13);
          var leftPosition = percentScrolled * 10;

          var startX = parseFloat($('.ma_inner').attr('data-scrolled-x'));
          var startY = parseFloat($('.ma_inner').attr('data-scrolled-y'));

          var startXmob = parseFloat($('.ma_inner').attr('data-scrolled-xmob'));
          var startYmob = parseFloat($('.ma_inner').attr('data-scrolled-ymob'));

          var startPercent = parseFloat($('.ma_inner').attr('data-percent-old'));

          var transformPercent = (percentScrolled - startPercent) * 3;

          // console.log(transformPercent, startPercent);

          var topPosition = startY - transformPercent;
          var leftPosition = startX - transformPercent;

          var topPositionmob = startYmob - (transformPercent);
          var leftPositionmob = startXmob - transformPercent;

          $('.ma_bg_image.Desktop_only').css('top', '-'+topPosition + 'px');
          $('.ma_bg_image.Desktop_only').css('left', '-'+leftPosition + 'px');

          $('.ma_bg_image.Mobile_only').css('top', '-'+topPositionmob + 'px');
          $('.ma_bg_image.Mobile_only').css('left', '-'+leftPositionmob + 'px');

          console.log(leftPosition);
          $('.ma_hero_slide[data="2slide"]').addClass('hidded');
          $('.ma_hero_slide[data="3slide"]').removeClass('hidded');
          $('.ma_hero_slide[data="4slide"]').addClass('hidded');
          $('.ma_hero_slide[data="5slide"]').addClass('hidded');
          $('.ma_hero_slide[data="6slide"]').addClass('hidded');
          $('.ma_hero_slide[data="7slide"]').addClass('hidded');

          $('.ma_inner').attr('data-scrolled-x',leftPosition);
          $('.ma_inner').attr('data-scrolled-y',topPosition);

          $('.ma_inner').attr('data-scrolled-xmob',leftPositionmob);
          $('.ma_inner').attr('data-scrolled-ymob',topPositionmob);

          $('.ma_inner').attr('data-percent-old', percentScrolled);
        }
         //  Fourth scene
         else if (percentScrolled > 40 && percentScrolled < 55){
          var transformPercent = ((percentScrolled/100) * 2) + 1;
          var topPosition = (percentScrolled * 13);
          var leftPosition = percentScrolled * 10;

          var startX = parseFloat($('.ma_inner').attr('data-scrolled-x'));
          var startY = parseFloat($('.ma_inner').attr('data-scrolled-y'));

          var startXmob = parseFloat($('.ma_inner').attr('data-scrolled-xmob'));
          var startYmob = parseFloat($('.ma_inner').attr('data-scrolled-ymob'));

          var startPercent = parseFloat($('.ma_inner').attr('data-percent-old'));

          var transformPercent = (percentScrolled - startPercent) * 3;

          console.log('ketvirta');

          var topPosition = startY - (transformPercent * 3);
          var leftPosition = startX - (transformPercent);

          var topPositionmob = startYmob - (transformPercent);
          var leftPositionmob = startXmob - (transformPercent* 2);

          $('.ma_bg_image.Desktop_only').css('top', '-'+topPosition + 'px');
          $('.ma_bg_image.Desktop_only').css('left', '-'+leftPosition + 'px');


          if (topPositionmob > 0){
            $('.ma_bg_image.Mobile_only').css('top', '-'+topPositionmob + 'px');
          }
          else{
            var topPositionNewmob =  Math.abs(topPositionmob);
            $('.ma_bg_image.Mobile_only').css('top', topPositionNewmob + 'px');
          }

          if (leftPositionmob > 0){
            $('.ma_bg_image.Mobile_only').css('left', '-'+leftPositionmob + 'px');
          }
          else{
            var leftPositionNewmob =  Math.abs(leftPositionmob);
            $('.ma_bg_image.Mobile_only').css('left', leftPositionNewmob + 'px');
          }
          

          // console.log(leftPosition);
          $('.ma_hero_slide[data="2slide"]').addClass('hidded');
          $('.ma_hero_slide[data="3slide"]').addClass('hidded');
          $('.ma_hero_slide[data="4slide"]').removeClass('hidded');
          $('.ma_hero_slide[data="5slide"]').addClass('hidded');
          $('.ma_hero_slide[data="6slide"]').addClass('hidded');
          $('.ma_hero_slide[data="7slide"]').addClass('hidded');

          $('.ma_inner').attr('data-scrolled-x',leftPosition);
          $('.ma_inner').attr('data-scrolled-y',topPosition);

          $('.ma_inner').attr('data-scrolled-xmob',leftPositionmob);
          $('.ma_inner').attr('data-scrolled-ymob',topPositionmob);

          $('.ma_inner').attr('data-percent-old', percentScrolled);

        }
        //  Fifth scene
        else if (percentScrolled > 55 && percentScrolled < 70){
          var transformPercent = ((percentScrolled/100) * 2) + 1;
          var topPosition = (percentScrolled * 13);
          var leftPosition = percentScrolled * 10;

          var startX = parseFloat($('.ma_inner').attr('data-scrolled-x'));
          var startY = parseFloat($('.ma_inner').attr('data-scrolled-y'));

          var startXmob = parseFloat($('.ma_inner').attr('data-scrolled-xmob'));
          var startYmob = parseFloat($('.ma_inner').attr('data-scrolled-ymob'));


          var startPercent = parseFloat($('.ma_inner').attr('data-percent-old'));

          var transformPercent = (percentScrolled - startPercent) * 3;

          // console.log(transformPercent, startPercent);

          var topPosition = startY - (transformPercent * 3);
          var leftPosition = startX - (transformPercent * 1.5);

          var topPositionmob = startYmob - (transformPercent);
          var leftPositionmob = startXmob - (transformPercent);


          // console.log(startX, startY, leftPosition, topPosition);

          if (topPosition > 0){
            $('.ma_bg_image.Desktop_only').css('top', '-'+topPosition + 'px');
          }
          else{
            var topPositionNew =  Math.abs(topPosition);
            $('.ma_bg_image.Desktop_only').css('top', topPositionNew + 'px');
          }

          if (leftPosition > 0){
            console.log(leftPosition, 'LEFT');
            $('.ma_bg_image.Desktop_only').css('left', '-'+leftPosition + 'px');
          }
          else{
            // console.log(leftPosition, 'LEFT');
            var leftPositionNew = Math.abs(leftPosition);
            // console.log(leftPosition, 'LEFT');
            $('.ma_bg_image.Desktop_only').css('left', leftPositionNew + 'px');
          }

          if (topPositionmob > 0){
            $('.ma_bg_image.Mobile_only').css('top', '-'+topPositionmob + 'px');
          }
          else{
            var topPositionNewmob =  Math.abs(topPositionmob);
            $('.ma_bg_image.Mobile_only').css('top', topPositionNewmob + 'px');
          }

          if (leftPositionmob > 0){
            $('.ma_bg_image.Mobile_only').css('left', '-'+leftPositionmob + 'px');
          }
          else{
            var leftPositionNewmob =  Math.abs(leftPositionmob);
            $('.ma_bg_image.Mobile_only').css('left', leftPositionNewmob + 'px');
          }

          // console.log(leftPosition);
          $('.ma_hero_slide[data="2slide"]').addClass('hidded');
          $('.ma_hero_slide[data="3slide"]').addClass('hidded');
          $('.ma_hero_slide[data="4slide"]').addClass('hidded');
          $('.ma_hero_slide[data="5slide"]').removeClass('hidded');
          $('.ma_hero_slide[data="6slide"]').addClass('hidded');
          $('.ma_hero_slide[data="7slide"]').addClass('hidded');

          $('.ma_inner').attr('data-scrolled-x',leftPosition);
          $('.ma_inner').attr('data-scrolled-y',topPosition);

          $('.ma_inner').attr('data-scrolled-xmob',leftPositionmob);
          $('.ma_inner').attr('data-scrolled-ymob',topPositionmob);

          $('.ma_inner').attr('data-percent-old', percentScrolled);

          // console.log('Old value', leftPosition);
        }
        //  Sixth scene
        else if (percentScrolled > 70 && percentScrolled < 80){
          var transformPercent = ((percentScrolled/100) * 2) + 1;
          var topPosition = (percentScrolled * 13);
          var leftPosition = percentScrolled * 10;

          var startX = parseFloat($('.ma_inner').attr('data-scrolled-x'));
          var startY = parseFloat($('.ma_inner').attr('data-scrolled-y'));

          var startXmob = parseFloat($('.ma_inner').attr('data-scrolled-xmob'));
          var startYmob = parseFloat($('.ma_inner').attr('data-scrolled-ymob'));

          var startPercent = parseFloat($('.ma_inner').attr('data-percent-old'));

          var transformPercent = (percentScrolled - startPercent) * 3;

          // console.log(transformPercent, startPercent);

          var topPosition = startY - (transformPercent * 3);
          var leftPosition = startX - (transformPercent * 2);

          var topPositionmob = startYmob - (transformPercent);
          var leftPositionmob = startXmob - (transformPercent * 2);


          // console.log(startX, startY, leftPosition, topPosition);

          if (topPosition > 0){
            $('.ma_bg_image.Desktop_only').css('top', '-'+topPosition + 'px');
          }
          else{
            var topPositionNew =  Math.abs(topPosition);
            $('.ma_bg_image.Desktop_only').css('top', topPositionNew + 'px');
          }

          if (leftPosition > 0){
            console.log(leftPosition, 'LEFT');
            $('.ma_bg_image.Desktop_only').css('left', '-'+leftPosition + 'px');
          }
          else{
            // console.log(leftPosition, 'LEFT');
            var leftPositionNew = Math.abs(leftPosition);
            // console.log(leftPosition, 'LEFT');
            $('.ma_bg_image.Desktop_only').css('left', leftPositionNew + 'px');
          }

          if (topPositionmob > 0){
            $('.ma_bg_image.Mobile_only').css('top', '-'+topPositionmob + 'px');
          }
          else{
            var topPositionNewmob =  Math.abs(topPositionmob);
            $('.ma_bg_image.Mobile_only').css('top', topPositionNewmob + 'px');
          }

          if (leftPositionmob > 0){
            $('.ma_bg_image.Mobile_only').css('left', '-'+leftPositionmob + 'px');
          }
          else{
            var leftPositionNewmob =  Math.abs(leftPositionmob);
            $('.ma_bg_image.Mobile_only').css('left', leftPositionNewmob + 'px');
          }
          

          
          console.log(topPosition, 'TOP');

          // console.log(leftPosition);
          $('.ma_hero_slide[data="2slide"]').addClass('hidded');
          $('.ma_hero_slide[data="3slide"]').addClass('hidded');
          $('.ma_hero_slide[data="4slide"]').addClass('hidded');
          $('.ma_hero_slide[data="5slide"]').addClass('hidded');
          $('.ma_hero_slide[data="6slide"]').removeClass('hidded');
          $('.ma_hero_slide[data="7slide"]').addClass('hidded');

          $('.ma_inner').attr('data-scrolled-x',leftPosition);
          $('.ma_inner').attr('data-scrolled-y',topPosition);

          $('.ma_inner').attr('data-scrolled-xmob',leftPositionmob);
          $('.ma_inner').attr('data-scrolled-ymob',topPositionmob);

          $('.ma_inner').attr('data-percent-old', percentScrolled);
        }
        //  Seventh scene
        else if (percentScrolled > 80 && percentScrolled < 110){
          var transformPercent = ((percentScrolled/100) * 2) + 1;
          var topPosition = (percentScrolled * 13);
          var leftPosition = percentScrolled * 10;

          var startX = parseFloat($('.ma_inner').attr('data-scrolled-x'));
          var startY = parseFloat($('.ma_inner').attr('data-scrolled-y'));

          var startXmob = parseFloat($('.ma_inner').attr('data-scrolled-xmob'));
          var startYmob = parseFloat($('.ma_inner').attr('data-scrolled-ymob'));

          var startPercent = parseFloat($('.ma_inner').attr('data-percent-old'));

          var transformPercent = (percentScrolled - startPercent) * 3;

          // console.log(transformPercent, startPercent);

          var topPosition = startY - (transformPercent * 3);
          var leftPosition = startX - (transformPercent );

          var topPositionmob = startYmob - (transformPercent  * 2);
          var leftPositionmob = startXmob - (transformPercent * 3);

          // console.log(startX, startY, leftPosition, topPosition);

          if (topPosition > 0){
            $('.ma_bg_image.Desktop_only').css('top', '-'+topPosition + 'px');
          }
          else{
            var topPositionNew =  Math.abs(topPosition);
            $('.ma_bg_image.Desktop_only').css('top', topPositionNew + 'px');
          }

          if (leftPosition > 0){
            console.log(leftPosition, 'LEFT');
            $('.ma_bg_image.Desktop_only').css('left', '-'+leftPosition + 'px');
          }
          else{
            // console.log(leftPosition, 'LEFT');
            var leftPositionNew = Math.abs(leftPosition);
            // console.log(leftPosition, 'LEFT');
            $('.ma_bg_image.Desktop_only').css('left', leftPositionNew + 'px');
          }

          if (topPositionmob > 0){
            // $('.ma_bg_image.Mobile_only').css('top', '-'+topPositionmob + 'px');
          }
          else{
            var topPositionNewmob =  Math.abs(topPositionmob);
            // $('.ma_bg_image.Mobile_only').css('top', topPositionNewmob + 'px');
          }

          if (leftPositionmob > 0){
            $('.ma_bg_image.Mobile_only').css('left', '-'+leftPositionmob + 'px');
          }
          else{
            var leftPositionNewmob =  Math.abs(leftPositionmob);
            $('.ma_bg_image.Mobile_only').css('left', leftPositionNewmob + 'px');
          }

          console.log(leftPosition);
          $('.ma_hero_slide[data="2slide"]').addClass('hidded');
          $('.ma_hero_slide[data="3slide"]').addClass('hidded');
          $('.ma_hero_slide[data="4slide"]').addClass('hidded');
          $('.ma_hero_slide[data="5slide"]').addClass('hidded');
          $('.ma_hero_slide[data="6slide"]').addClass('hidded');
          $('.ma_hero_slide[data="7slide"]').removeClass('hidded');

          $('.ma_inner').attr('data-scrolled-x',leftPosition);
          $('.ma_inner').attr('data-scrolled-y',topPosition);

          $('.ma_inner').attr('data-scrolled-xmob',leftPositionmob);
          $('.ma_inner').attr('data-scrolled-ymob',topPositionmob);

          $('.ma_inner').attr('data-percent-old', percentScrolled);
        }
      }
    });

});

document.addEventListener("DOMContentLoaded", function() {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
  
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  });